import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  columnsSchema,
  planningGridViewTypeEnum,
  type column,
} from '../shared/schemas/columns.js';
import { GetMediaDataResponseSchema } from '../shared/schemas/mediaData.js';

export type Column = z.infer<typeof column>;
export type ColumnsResponse = z.infer<typeof columnsSchema>;

export {
  planningGridViewTypeEnum,
  type PlanningGridViewType,
} from '../shared/schemas/columns.js';

export const updateColumn = defaultApi.declareEndpoint({
  url: 'planning-service/media-lines/$mediaDataId/' as const,
  method: 'PATCH',
  responseSchema: GetMediaDataResponseSchema,
  requestSchema: z.record(z.string(), z.any()),
});

export const getColumnsListQueryOptions = defaultClient.query({
  url: 'planning-service/taxonomy/columns/' as const,
  method: 'GET',
  responseSchema: columnsSchema,
  querySchema: z.object({
    mediaDataId: z.string(),
  }),
  processResponse(data) {
    return data;
  },
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});

export const getUpdateColumnQueryOptions = makeQueryOptions(updateColumn, {
  processResponse(data) {
    return data;
  },
});

export const getColumnsListByViewQueryOptions = defaultClient.query({
  url: 'planning-service/media-plans/$planId/columns/' as const,
  method: 'GET',
  responseSchema: columnsSchema,
  querySchema: z.object({
    view: planningGridViewTypeEnum,
  }),
  processResponse(data) {
    return data;
  },
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});

export const updateColumnsSchema = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$planId/columns/' as const,
  method: 'PUT',
  responseSchema: z.unknown(),
  requestSchema: z.object({
    columns: z.array(z.string()),
    view: planningGridViewTypeEnum,
  }),
});
